module.exports = __webpack_public_path__ + "img/title.ff5e61bd.svg";